import React from "react";
import { cn } from "@/lib/utils";
import type { FC } from "react";
import { getInterestColor } from "@/util/getInterestColor";

interface InterestPillProps {
  label: string;
  className?: string;
}

export const InterestPill: FC<InterestPillProps> = ({
  label,
  className,
  ...rest
}) => {
  const color = getInterestColor(label);

  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full border px-[11px] py-[3px] text-xs font-medium",
        color.bg,
        color.text,
        color.border,
        className,
      )}
      {...rest}
    >
      {label}
    </span>
  );
};
